import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from 'highcharts-react-official';
import mapa from "./Mapas.js";
import { useEffect } from "react";
import { useState } from "react";
import { mapas } from "../../assets/mapas/arraymapas.js";
// Load Highcharts modules
require("highcharts/modules/map")(Highcharts);

const LoginMapa = (props) => {
    const {datos, nacional} = props;
    const [mapOptions, setMapOptions] = useState();

    useEffect(() => {
        //Opciones para el mapa
        const mapOptionsAux = {
            accessibility: {
                enabled: false
            },

            title: {
                text: ""
            },
            
            chart: {
                backgroundColor: 'none',
                height: nacional ? 500 : 350
            },

            exporting: {
                enabled: false
            },
        
            credits: {
                enabled: false
            },
        
            legend: {
                enabled: false
            },

            mapNavigation: {
                enabled: false,
                enableButtons: false
            },

            tooltip:{
                backgroundColor: "#ffffff",
                borderWidth: 1,
                borderColor: "#b2b2b2",
                shadow: false
            },

            plotOptions: {
                map: {
                    animation: false,
                    mapData: nacional ? mapa : mapas.find(mapaux => mapaux.id === datos.idEstado).mapa,
                    joinBy: ["ID", "idEstado"],
                    color: '#DABEF8',
                    tooltip: {
                        headerFormat: '',
                        pointFormat: nacional ? "<b>{point.nombreEstado}</b><br/>{point.acreditadas} acreditados<br/>{point.porcentajeAcreNac}% de observadoras/es<br/>a nivel nacional"
                        : "<b>{point.nombreEstado}</b><br/>{point.acreditados} acreditados<br/>{point.porcentajeAcreNac}% de observadoras/es<br/>a nivel nacional",
                        useHTML: true
                    }
                }
            },

            series: [
                {
                    data: nacional ? datos : [datos],
                    borderColor: "#b2b2b2",
                    borderWidth: 1,
                    states: {
                        hover: {
                            color: '#9159CB'
                        }
                    }
                }
            ]
        };

        setMapOptions(mapOptionsAux);
        
        //Para no marcar el warning 21 de Highcharts y no descargar otra biblioteca 
        const script = document.createElement('script');
        script.src = "https://cdnjs.cloudflare.com/ajax/libs/proj4js/2.8.0/proj4.js";
        script.async = true;
        document.body.appendChild(script);
        return () => {
            document.body.removeChild(script);
        }
    },[datos, nacional]);

    return (
        <div>
            <HighchartsReact options={mapOptions}
                constructorType={'mapChart'}
                highcharts={Highcharts}
                immutable={true}
            />
        </div>
    );
};

export default LoginMapa;